import pino from 'pino'

const logger = pino({
  name: 'twlvxtwlv-marketplace',
  level: process.env.LOG_LEVEL ?? 'info',
  timestamp: pino.stdTimeFunctions.isoTime,
})

export { logger }
